module.exports = __webpack_public_path__ + "static/112_001-ea05903a2525e53c35e668450542e6ef.jpg";